module.exports = __webpack_public_path__ + "img/Logo Tropa.e91fb8ad.png";